import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar({ theme, handleThemeChange, profileData, signOut, info, user }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const isAuthenticated = !!user;

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleSignOut = () => {
    closeDropdown();
    signOut();
  };

  const handleSignIn = () => {
    closeDropdown();
    // Amplify will handle the sign in flow
    navigate('/');
  };

  const handleProfileClick = () => {
    closeDropdown();
    navigate('/profile');
  };

  return (
    <div className="navbar bg-base-300">
      <div className="flex-1">
        <Link to="/" className="btn btn-ghost text-xl">Custom App</Link>
        <Link to="/" className="btn btn-ghost">Home</Link>
        <Link to="/subscribe" className="btn btn-ghost">Pricing</Link>
        {isAuthenticated && (
          <Link to="/chat" className="btn btn-ghost">Chat</Link>
        )}
      </div>
      <div className="flex-none gap-2">
        <div className="dropdown dropdown-end">
          <div tabIndex={0} role="button" className="btn m-1">
            Theme: {theme}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7l3-3 3 3m0 6l-3 3-3-3"></path></svg>
          </div>
          <ul tabIndex={0} className="dropdown-content z-[1] p-2 shadow-lg bg-base-200 rounded-box w-52 max-h-[70vh] overflow-y-auto">
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('light')}>Light</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('dark')}>Dark</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('cupcake')}>Cupcake</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('bumblebee')}>Bumblebee</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('emerald')}>Emerald</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('corporate')}>Corporate</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('synthwave')}>Synthwave</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('cyberpunk')}>Cyberpunk</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('valentine')}>Valentine</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('halloween')}>Halloween</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('garden')}>Garden</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('forest')}>Forest</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('aqua')}>Aqua</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('lofi')}>Lofi</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('pastel')}>Pastel</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('fantasy')}>Fantasy</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('wireframe')}>Wireframe</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('black')}>Black</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('luxury')}>Luxury</button></li>
            <li><button className="btn btn-sm btn-block" onClick={() => handleThemeChange('dracula')}>Dracula</button></li>
          </ul>
        </div>
        {isAuthenticated ? (
          <div className="dropdown dropdown-end">
            <div 
              tabIndex={0} 
              role="button" 
              className="avatar cursor-pointer" 
              onClick={toggleDropdown}
            >
              <div className="w-10 rounded-full">
                {profileData?.profilePictureUrl ? (
                  <img src={profileData.profilePictureUrl} alt="Profile" />
                ) : (
                  <div className="bg-primary text-neutral-content rounded-full w-10 h-10 flex items-center justify-center">
                    <span>{(info?.username?.[0] || user?.username?.[0] || 'U').toUpperCase()}</span>
                  </div>
                )}
              </div>
            </div>
            {isDropdownOpen && (
              <ul 
                tabIndex={0} 
                className="dropdown-content z-[1] menu p-2 shadow bg-base-200 rounded-box w-52"
              >
                <li><button onClick={handleProfileClick}>Profile</button></li>
                <li><button onClick={handleSignOut}>Sign out</button></li>
              </ul>
            )}
          </div>
        ) : (
          <div className="dropdown dropdown-end">
            <div 
              tabIndex={0} 
              role="button" 
              className="avatar cursor-pointer" 
              onClick={toggleDropdown}
            >
              <div className="bg-gray-400 text-neutral-content rounded-full w-10 h-10 flex items-center justify-center">
                <span>?</span>
              </div>
            </div>
            {isDropdownOpen && (
              <ul 
                tabIndex={0} 
                className="dropdown-content z-[1] menu p-2 shadow bg-base-200 rounded-box w-52"
              >
                <li><button onClick={handleSignIn}>Sign in</button></li>
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
